export const GetHistoryCryptoForm = "/Request/GetHistoryCryptoForm";

export const GetHistoryFiatForm = "GetHistoryFiatForm";

export const GetHistoryCryptoList = ({
  selectType,
  SelectedCoin,
  selectDateFrom,
  selectDateTo,
  selectedState,
  SelectedPage,
  showPerPage,
}) =>
  `/Request/GetHistoryCryptoList?SideId=${selectType}&CoinId=${SelectedCoin}&StartDate=${selectDateFrom}&EndDate=${selectDateTo}&StateId=${selectedState}&PageNumber=${SelectedPage}&PageSize=${showPerPage}`;

export const GetHistoryFiatList = ({
  selectType,

  selectDateFrom,
  selectDateTo,
  selectedState,
  SelectedPage,
  showPerPage,
}) =>
  `/Request/GetHistoryFiatList?SideId=${selectType}&StartDate=${selectDateFrom}&EndDate=${selectDateTo}&StateId=${selectedState}&PageNumber=${SelectedPage}&PageSize=${showPerPage}`;

//   margin wallet
export const GetHistoryList = ({
  typeId,
  coinId,
  dateFrom,
  dateTo,
  transferId,
  repayId,
  pageNumber,
  pageSize,
}) =>
  `/MarginWallet/GetHistoryList?TypeId=${typeId}&CoinId=${coinId}&StartDate=${dateFrom}&EndDate=${dateTo}&TypeTransferId=${transferId}&TypeRepaymentId=${repayId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetHistoryForm = `/MarginWallet/GetHistoryForm`;
